import React from 'react'
import type { HTMLXStyledProps } from '../../system'
import { forwardRef } from '../../system'
import { MoteCardMediumContainer } from './MoteCardMediumContainer'

export interface MoteCardMediumLayoutProps extends HTMLXStyledProps<'div'> {}

export const MoteCardMediumLayout = forwardRef<
  MoteCardMediumLayoutProps,
  'div'
>((props, ref): JSX.Element => {
  return <MoteCardMediumContainer ref={ref} {...props} />
})
